import React, { Component } from 'react';
import logo from './logo.svg';
import axios from 'axios';
import './Expansion.css';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { RosterTable } from '../Components/RosterTable';
import { CustomNav } from '../Components/CustomNav';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';

export class Expansion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerListAway: [],
      teams_info: [],
      team_selections: []
    };
  }

  toggleActive() {}
  componentDidMount(props) {
    let currentComponent = this;
    // Make a request for a user with a given ID
    // axios
    //   .get(apiServerUrl + "/prospects", requestOptions())
    //   .then(function(response) {
    //     ////console.log(response);
    //     ////console.log("remote players "  + response.data.players);
    //     currentComponent.setState({
    //       prospects: response.data.players
    //       //selectedPlayer: response.data.players[0]
    //     });
    //   })
    //   .catch(function(error) {
    //     //console.log(error);
    //   });
    axios
      .all([
        axios.get(
          apiServerUrl + '/team_players?team=' + 'ANA', //this.state.awayTeam,
          requestOptions()
        )
      ])
      .then(
        axios.spread(awayRes => {
          //console.log(homeRes.data);
          //console.log(awayRes.data);
          if (awayRes.data) {
            currentComponent.setState({
              playerListAway: awayRes.data.players
            });
          }
        })
      );
  }

  render() {
    const data = [
      {
        team: 'PHI',
        selected_player: 'John Tavares'
      },
      {
        team: 'PIT',
        selected_player: 'John a'
      },
      {
        team: 'TBL',
        selected_player: 'John ss'
      },
      {
        team: 'CBJ',
        selected_player: 'John sss'
      },
      {
        team: 'TBL',
        selected_player: 'John ss'
      },
      {
        team: 'CBJ',
        selected_player: 'John sss'
      },
      {
        team: 'TBL',
        selected_player: 'John ss'
      },
      {
        team: 'CBJ',
        selected_player: 'John sss'
      }
    ];
    return (
      <div style={{ color: 'white' }}>
        <header className="nav">
          <CustomNav />
        </header>
        <div>
          <div className="flex-container">
            <div class="division-item">
              <h2>Division</h2>
              {data.map((entry, index) => (
                <div class="team-item">
                  {entry.team} - {entry.selected_player}
                </div>
              ))}
            </div>
            <div class="division-item">
              {' '}
              <h2>Division</h2>
              {data.map((entry, index) => (
                <div class="team-item">
                  {entry.team} - {entry.selected_player}
                </div>
              ))}
            </div>
            <div class="division-item">
              {' '}
              <h2>Division</h2>
              {data.map((entry, index) => (
                <div class="team-item">
                  {entry.team} - {entry.selected_player}
                </div>
              ))}
            </div>
            <div class="division-item">
              {' '}
              <h2>Division</h2>
              {data.map((entry, index) => (
                <div class="team-item">
                  {entry.team} - {entry.selected_player}
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div>
              {this.state.playerListAway.length > 0 && (
                <RosterTable
                  team={this.state.playerListAway}
                  activeTeam={this.state.awayTeam}
                  selectedPlayer={this.state.selectedPlayer}
                  addPlayer={this.addPlayer}
                  side={'right'}
                  toggleActive={this.toggleActive}
                  data={this.state.nonRostered}
                />
              )}
            </div>
            <div>
              <div>
                <div style={{ backgroundColor: 'red' }}>
                  <div>
                    <h2>Division name Next</h2>
                    <h2>Team name</h2>
                  </div>
                  <div>
                    <h3>List of Scenarios</h3>
                    <div>D Heavy</div>
                    <div>F Heavy</div>
                    <div>G Heavy</div>
                    <div>Add Scenario</div>
                  </div>
                  <div>
                    <h3>List of Players</h3>
                    <div>S Crosby</div>
                    <div>P Bergeron</div>
                    <div>E Lindros</div>
                    <div>D Phaneuf</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Expansion;



// WEBPACK FOOTER //
// ./src/Pages/Expansion.js